// @owners { team: patients-team }
import { type FertilityCycleMedicationType } from '@alto/scriptdash/alto/fertility_cycles/types/v1/fertility_cycle_medication_type';
import { createSelector } from 'reselect';
import { getProgynyWizardEligiblePrescriptions } from './getProgynyWizardEligiblePrescriptions';
import { type EligiblePrescription } from '~shared/reducers/ui/progynyWizard';
import { type ReduxStateShared } from '~shared/types';

export const getEligiblePrescriptionMedTypes: (state: ReduxStateShared) => FertilityCycleMedicationType[] =
  createSelector(
    [getProgynyWizardEligiblePrescriptions],
    (eligiblePrescriptions: EligiblePrescription[] | null | undefined) => {
      return eligiblePrescriptions?.map((rxMed) => rxMed.medicationType) || [];
    },
  );
